import Header from "../../../components/Header"
import { useEffect, useState } from "react"
import { getGenres, getMovieDetails, getWatchlist, removeFromWatchlist, updateWatchlist } from "../../../redux/functions/vod"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import Loader from "../../../components/Loader"
import secondsToReadableTime from "../../../utils/secondsToReadableTime.util"
import getGenreName from "../../../utils/vod/getGenreName.util"
import getVODImage from "../../../utils/vod/getVODImage.util"
import Button from "../../../components/buttons/Button"
import share from "../../../utils/share.util"
import Footer from "../../../components/Footer"

const Movie = () => {
    const dispatch = useDispatch()
    const { id, type } = useParams()
    const { vodDetailsLoading } = useSelector(state => state.ui)
    const [vodDetails, setVODDetails] = useState({})
    const [genre, setGenre] = useState("")
    const [watchlisted, setWatchlisted] = useState(true)
    const [watchlist, setWatchlist] = useState([])

    useEffect(() => {
        const init = async () => {
            setVODDetails(await getMovieDetails(id, type, dispatch))
            setWatchlist(await getWatchlist())
        }
        init()
    }, [])

    useEffect(() => {
        const getGenreDetails = async () => {
            if (vodDetails && vodDetails.genres) {
                setGenre(getGenreName(vodDetails.genres, await getGenres()))
            }
        }
        getGenreDetails()
    }, [vodDetails])

    useEffect(() => {
        const initCheckIsWatchlisted = () => {
            if (!vodDetails) return

            let _ids = []
            for (let i = 0; i < watchlist.length; i++) {
                const element = watchlist[i];
                _ids.push(element.movie_id)
            }
            if (_ids.includes(vodDetails.id)) setWatchlisted(true)
            else setWatchlisted(false)
        }
        initCheckIsWatchlisted()
    }, [vodDetails, watchlist])

    const toggleAddToWatchlist = (action) => {
        setWatchlisted(!watchlisted)
        if (action === 'add') updateWatchlist(vodDetails.id, 'movie', 0)
        if (action === 'remove') removeFromWatchlist(vodDetails.id, 'movie')
    }

    if (vodDetailsLoading) return (
        <Loader />
    )

    if (vodDetails) return (
        <>
            <Header />
            <wc-toast></wc-toast>
            <main>
                <div className={styles.banner}>
                    <div className={styles.bannerWrapper}>
                        <div className={styles.bannerContent}>

                            <div>
                                {vodDetails.images
                                    ? <img className="w-full lg:w-max max-w-[180px] m-auto lg:max-w-[300px] lg:mb-0 mb-5 border-[3px] border-[#fff] rounded-md" src={getVODImage(vodDetails.image_store_id)} alt={"poster of " + vodDetails.title} />
                                    : <></>}
                            </div>

                            <div className="lg:ml-6">
                                <h1 className="text-4xl text-secondary font-medium mb-3">{vodDetails.title}</h1>
                                <div className="flex flex-wrap items-center mb-3">
                                    <div className="m-1">
                                        <Button page={"/watch/movie/" + vodDetails.uid + "?i=" + vodDetails.id + "&t=" + vodDetails.title} label="Watch movie" />
                                    </div>
                                    <div className="m-1">
                                        {
                                            watchlisted
                                                ? <Button action={() => toggleAddToWatchlist("remove")} label="Remove from watchlist" />
                                                : <Button action={() => toggleAddToWatchlist("add")} label="Add to watchlist" />
                                        }
                                    </div>
                                    <div className="m-1">
                                        <Button action={() => share(vodDetails)} label="Share" />
                                    </div>
                                </div>
                                <p className="text-[16px] lg:text-[20px]">{vodDetails.description}</p>
                                <div>
                                    <p className="mt-8 mb-3">{secondsToReadableTime(vodDetails.duration)} | {vodDetails.year} | {vodDetails.user_rating}</p>
                                    <div className="flex items-center">
                                        <b>Genre:&nbsp;</b>
                                        <p>{genre}</p>
                                    </div>
                                    {
                                        vodDetails.audio_languages
                                            ? <div className="flex items-center">
                                                <b>Audio:&nbsp;</b>
                                                <p>{vodDetails.audio_languages}</p>
                                            </div>
                                            : <></>
                                    }
                                    {
                                        vodDetails.subtitle_languages
                                            ? <div className="flex items-center">
                                                <b>Subtitles:&nbsp;</b>
                                                <p>{vodDetails.subtitle_languages}</p>
                                            </div>
                                            : <></>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        vodDetails.image_store_id
                            ? <div className="fixed top-0 left-0 w-screen h-screen">
                                <img className={styles.bannerBgImg} src={getVODImage(vodDetails.images.PREVIEW || vodDetails.image_store_id)} alt={"poster of " + vodDetails.title} />
                                <div className="banner-gradient vod-details-gradient" />
                            </div>
                            : <></>
                    }
                </div>
                <Footer />
                {/* <div className={styles.bannerSlid ? <div className="fixed top-0 w-screen h-screen">e}>
                    <Carousel maxLines={1} showTitles title="Section #3" items={[{}, {}, {}, {}, {}, {}, {}, {}]} />
                </div> */}
            </main>
        </>
    )

    return (
        <>
            <Header />
        </>
    )
}

const styles = {
    banner: `text-[#fff] flex flex-col items-center -mt-[60px]`,
    bannerWrapper: `z-10 w-screen mt-[100px] pb-32 max-w-[1300px] m-auto`,
    bannerContent: `lg:flex mt-10 p-5`,
    bannerSlide: `z-50 w-screen`,
    bannerBgImg: `absolute top-0 left-0 h-full w-full object-cover`,
}

export default Movie